/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import type { BlockPageEntry, PageEntry, PresetPageEntry } from './api/pageStructure';

// The page-structure types are ONE definition with the server's route, in
// src/types/api/pageStructure.ts (type-only); re-exported here, next to the two
// guards every page that renders an entries list uses.
export type {
  BlockPageEntry,
  PageEntry,
  PageId,
  PageStructure,
  PageStructureFile,
  PresetPageEntry,
} from './api/pageStructure';

export function isPresetEntry(e: PageEntry): e is PresetPageEntry {
  return e.kind === 'preset';
}

export function isBlockEntry(e: PageEntry): e is BlockPageEntry {
  return e.kind === 'block';
}
